import { TApiTechnician } from "../../lib/types/dentalTechs";
import { TProcessStates } from "../../lib/types/general";
import { phoneRegex } from "../../lib/common/validation";
import { useEffect, useRef, useState } from "react";

export type TDentalTechInfoContactEditProps = {
    userInfo: TApiTechnician;
    saveContactCallback: (linkedinValue: string | undefined, phoneValue: string | undefined) => void;
    cancelEditContactCallback: () => void;
    currWorkingState: TProcessStates;
    setCurrWorkingState: (state: TProcessStates) => void;
    workingState: TProcessStates;
};

export const useDentalTechInfoContactEdit = ({
    cancelEditContactCallback,
    currWorkingState,
    saveContactCallback,
    setCurrWorkingState,
    userInfo,
    workingState,
}: TDentalTechInfoContactEditProps) => {
    const [errorPhone, setErrorPhone] = useState("");
    const refLinkedin = useRef<any>({});
    const refPhone = useRef<any>({});

    const saveContact = async () => {
        setCurrWorkingState("working");

        let linkedinValue = refLinkedin.current.value;
        const linkedinUrlPattern = /^https:\/\/www\.linkedin\.com\/in\/(.+)$/;
        const linkedinUser = linkedinValue.match(linkedinUrlPattern);
        if (linkedinUser) {
            linkedinValue = linkedinUser[1];
        }

        const phoneValid = refPhone.current.value?.trim() || "";

        let hasError = false;

        if (!phoneValid) {
            setErrorPhone("Phone number is required.");
            setCurrWorkingState("error");
            hasError = true;
        } else if (!!phoneValid && !phoneRegex.test(phoneValid)) {
            setErrorPhone("Please enter a valid 10-digit US phone number.");
            setCurrWorkingState("error");
            hasError = true;
        } else {
            setErrorPhone("");
        }

        if (hasError) {
            return;
        }

        saveContactCallback(linkedinValue, phoneValid);
    };

    const cancelHandler = async () => {
        refLinkedin.current.value = `https://www.linkedin.com/in/${userInfo?.other?.linkedin}`;
        cancelEditContactCallback();
    };

    useEffect(() => {
        refLinkedin.current.value = userInfo?.other?.linkedin ? `https://www.linkedin.com/in/${userInfo.other.linkedin}` : "";
        refPhone.current.value = userInfo?.other?.phone || "";
        //eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return {
        refPhone,
        refLinkedin,
        errorPhone,
        saveContact,
        cancelHandler,
        userInfo,
        workingState,
        currWorkingState,
    };
};
